import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';
import qs from 'query-string';

import {
  API_ENDPOINT,
  type ClientApiV1MockInterviewProductQueryString,
  useClientApiV1MockInterviewProductQuery,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewProductQuery {
  params?: ClientApiV1MockInterviewProductQueryString;
  options?: Parameters<typeof useClientApiV1MockInterviewProductQuery>[0]['options'];
}

export function useMockInterviewProductQuery({
  params,
  options,
}: UseClientV1MockInterviewProductQuery) {
  return useClientApiV1MockInterviewProductQuery({
    queryKey: getMockInterviewProductQueryKey(params),
    url: getMockInterviewProductUrl(params),
    options,
  });
}

export const getMockInterviewProductQueryKey = (
  params?: ClientApiV1MockInterviewProductQueryString,
): QueryKeyReturnType => [API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_PRODUCT, params ?? {}];

export const getMockInterviewProductUrl = (
  params?: ClientApiV1MockInterviewProductQueryString,
): string =>
  qs.stringifyUrl({
    url: API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_PRODUCT,
    query: { ...params },
  });

export default useMockInterviewProductQuery;
